import { StoreEditComponent } from './store-edit.component';

export default StoreEditComponent;
